import portrait from './consumer/portrait.json';
import square from './consumer/square.json';
import landscape from './consumer/landscape.json';
import init from './default.json';

export default {
  portrait,
  square,
  landscape,
  init,
};



// WEBPACK FOOTER //
// ./src/config/templates/layouts/consumer.jsx